import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./psxTicker.css";

const API_URL = `${process.env.REACT_APP_URL}/api/market-summary`;

const PSXTicker = () => {
  const history = useHistory();

  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("Fetching market summary...");
        const headers = new Headers({
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY,
          "ngrok-skip-browser-warning": "true",

        });
        const params = new URLSearchParams({
          limit: 20,
        });
        const res = await fetch(`${API_URL}?${params}`, {
          method: "GET",
          headers: headers,
        });
        const data = await res.json();

        // only most active
        setStocks(data.most_active || []);

      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="ticker-wrapper">
      <div className="ticker-track">
        {[...stocks, ...stocks].map((s, i) => (
          <div
            className="ticker-item"
            key={i}
            onClick={() =>
              history.push(`/trading-dashboard/${s.code}`)
            }
            style={{ cursor: "pointer" }}
          >
            <span className="symbol">
              {s.code}
            </span>

            <span className="price">
              {Number(s.last_price).toFixed(2)}
            </span>

            <span
              className={`change ${s.change >= 0 ? "up" : "down"
                }`}
            >
              {s.change > 0 ? "+" : ""}
              {s.change}

              {s.change > 0
                ? " ▲"
                : s.change < 0
                  ? " ▼"
                  : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PSXTicker;